import pinia from '@/stores';

import { useBaseInfoStore } from '@/stores/base-info';

const useBaseInfo = useBaseInfoStore(pinia);

/**
 * 更新并返回时间差
 * 根据store中的服务器时间和当前客户端时间进行计算，即需要在返回服务器时间后立即进行计算
 * @returns {number|undefined} 时间差
 */
const updateTimeDiff = () => {
  const serverTime = useBaseInfo.latestServerTime;
  if (!serverTime) {
    console.warn('[updateTimeDiff] failed, cause [serverTime] is not exists');
    return undefined;
  }

  const timeDiff = new Date() - serverTime.getTime();
  useBaseInfo.setTimeDiff(timeDiff);
  return timeDiff;
};

/**
 * 根据时间差获取服务器时间
 * @param {Date} [clientTime] 客户端时间，不传该值表示当前客户端时间
 * @returns {Date|undefined}
 */
const getServerTimeByDiff = (clientTime) => {
  const timeDiff = useBaseInfo.serverClientTimeDiff;
  if (!timeDiff && timeDiff !== 0) {
    // console.warn(
    //   '[getServerTimeByDiff] failed, cause [timeDiff] is not exists',
    // );
    return undefined;
  }

  const newClientTime = clientTime || new Date();
  return new Date(newClientTime.getTime() - timeDiff);
};

/**
 * 根据时间差获取客户端时间
 * @param {Date} serverTime 服务端时间
 * @returns {Date|undefined}
 */
const getClientTimeByDiff = (serverTime) => {
  // 获取之前先更新一下，获取最新的。
  updateTimeDiff();
  const timeDiff = useBaseInfo.serverClientTimeDiff;
  if (!timeDiff && timeDiff !== 0) {
    console.warn(
      '[getServerTimeByDiff] failed, cause [timeDiff] is not exists',
    );
    return undefined;
  }

  return new Date(serverTime.getTime() + timeDiff);
};

export { getClientTimeByDiff, getServerTimeByDiff, updateTimeDiff };
